import { useOwnerStatistics } from 'customer/customer-home/customer-home.service'
import React from 'react'

const DataView = ({preBalance}) => {
  const {ownerStatic}=useOwnerStatistics()

  return (
    <div className='dataView'>
        <p className='balance previous'>Previous Balance : <span className='number'>{ Math.round((preBalance + Number.EPSILON) * 100) / 100}</span><span> SAR</span></p>
        <p className='balance current'>Your Current Balance : <span className='number'>{ Math.round((ownerStatic?.localBalance + Number.EPSILON) * 100) / 100}</span><span> SAR</span> </p>
    </div>
  )
}

export default DataView